<template>
<transition name="slide-fade">
    <div class="dialog-view" id="tips-view" v-show="visible" @click="destroyElement">        
        <div class="tips-modal u-window">           
            <div class="tips-content">
                <div class="content" v-html="tips_contxt">加载中……</div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'tips-app',
    data : function () {
        return {
            visible : false,
            item_id : '',
            data : () => {},
            tips_contxt : '',
            text : '',
            type : 'text',
            src : 'https://web-resource.17m3.com/m3guo/202209/ck/tips/',
            ready : false,            
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                //this.destroyElement()
            }
        },
        item_id (newVal){
            if (newVal) {
                this.getContext (newVal);
                //this.text = this.type != 'img' ? this.data.filter(function(e){return e.id == newVal})[0].desc : '';
                //this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.text) : '<div class="img"><img src="'+ this.src + newVal +'" style="width:100%"></div>';
            }            
        }        
    },
    methods: {
        destroyElement () {
            // this.$destroy()
            // this.$el.parentNode.removeChild(this.$el)
            this.visible = false;
            this.type = 'text';
        },
        fuckTipsTxtFormat(text){

            if(!text)return '';

            return text
            .replace(/\|r\|n\|cff99d3ff\s\|r\d{0,2}\.{0,1}\|pUI.*?\|e\|(\w{9})/gi, '|r|n|$1')
            .replace(/\|r\|pUI(.*?)\|e\|\S*/g, '').replace(/\|n/g, '<br/>')
            .replace(/\|cff(\w{6})/gi, '<span style="color:#$1">')
            .replace(/\|r/g, '</span>');
        },
        getContext (id){
            let vm = this;
            if(!tips_data[vm.item_id]){
                vm.tips_contxt = '';
                vm.$axios({
                    method: 'get',
                    url: ajax_url_map.tips,
                    params:{
                        id : vm.item_id,
                        '_': +new Date(),
                    },
                    withCredentials: true,
                    responseType: 'json',
                    headers: {},
                })
                .then(res => {
                        //this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.data[this.item_id]) : '<div class="img"><img src="'+ this.src + this.item_id +'" style="width:100%"></div>';
                    },rej => {
                        //sick code
                        if(rej.code == 1){
                            //success
                            vm.data = rej.data[0];

                            tips_data[id] = rej.data[0];
                            vm.setHtml();
                        }
                    })
                .catch(err=>{
                    console.error(err);
                })          
            }
            else{
                vm.data = tips_data[vm.item_id];
                vm.setHtml();
            }            
        },
        setHtml (){
            var temp = this.data ? this.data.desc : '';
            this.text = temp;
            let file = this.item_id == 'Y552' ? 'gif' : 'png';
            this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.text) : (this.fuckTipsTxtFormat(this.text) + '<div class="img"><img src="'+ this.src + this.item_id +'.'+ file +'"></div>');            
        },
    }    
}
</script>

<style scoped>

    #tips-view{
        z-index: 100;
    }

    .tips-content{
        width: 750px;
        color: #fff;
        z-index: 100;
    }
    
    .tips-content .content{
        padding: 0 30px;
    }

</style>

<style>

    .tips-content .img{
        text-align: center;
    }

    .tips-content .content img{
        width: 100%;
        text-align: center;
    }

    @media screen and (min-width:751px) {
        .tips-content .content img{
            width: auto;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ItemTips/itemTips.vue